import { useEffect } from 'react';

function useOnEscapeKeypress(handler) {

  useEffect(function registerForEvents() {

    function documentKeyHandler(event) {

      if (event.key !== 'Escape') {
        return;
      }

      return handler(event);

    }

    document.addEventListener('keydown', documentKeyHandler);

    return function unregisterEvents() {
      document.removeEventListener('keydown', documentKeyHandler);
    };
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
  }, [handler]);

}

export default useOnEscapeKeypress;